"use strict";
// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.6.1
//   protoc               v5.29.3
// source: commercial_property/commercial_listing.proto
Object.defineProperty(exports, "__esModule", { value: true });
exports.StandardizedAddress = exports.CommercialListingData = exports.protobufPackage = void 0;
/* eslint-disable */
const wire_1 = require("@bufbuild/protobuf/wire");
const agent_1 = require("./agent");
const media_1 = require("./media");
exports.protobufPackage = "commercial_property";
function createBaseCommercialListingData() {
    return {
        odataId: "",
        listingKeyNumeric: 0,
        sourceSystemKey: "",
        sourceSystemName: "",
        unparsedAddress: "",
        city: "",
        stateOrProvince: undefined,
        postalCode: undefined,
        country: "",
        latitude: 0,
        longitude: 0,
        location: "",
        countyOrParish: "",
        crossStreet: "",
        zoningDescription: "",
        apiModificationTimestamp: "",
        standardStatus: "",
        propertySubType: "",
        propertyType: "",
        propertyDescription: "",
        lotSizeAcres: undefined,
        stories: undefined,
        yearBuilt: undefined,
        parkingTotal: undefined,
        capRate: undefined,
        daysOnMarket: undefined,
        listPrice: undefined,
        priceLabel: undefined,
        netOperatingIncome: undefined,
        listAgentKeyNumeric: undefined,
        expDataSourceKey: undefined,
        listingId: "",
        buildingClass: undefined,
        occupancyPct: undefined,
        salePricePerUnit: undefined,
        highlights: [],
        locationDescription: undefined,
        youTubeUrl: undefined,
        name: undefined,
        media: [],
        documents: [],
        agents: [],
        buildingSize: undefined,
        thumbnailImage: undefined,
        isSale: false,
        standardizedAddress: undefined,
        slug: undefined,
        stateName: undefined,
    };
}
exports.CommercialListingData = {
    encode(message, writer = new wire_1.BinaryWriter()) {
        if (message.odataId !== "") {
            writer.uint32(10).string(message.odataId);
        }
        if (message.listingKeyNumeric !== 0) {
            writer.uint32(16).int64(message.listingKeyNumeric);
        }
        if (message.sourceSystemKey !== "") {
            writer.uint32(26).string(message.sourceSystemKey);
        }
        if (message.sourceSystemName !== "") {
            writer.uint32(34).string(message.sourceSystemName);
        }
        if (message.unparsedAddress !== "") {
            writer.uint32(42).string(message.unparsedAddress);
        }
        if (message.city !== "") {
            writer.uint32(50).string(message.city);
        }
        if (message.stateOrProvince !== undefined) {
            writer.uint32(58).string(message.stateOrProvince);
        }
        if (message.postalCode !== undefined) {
            writer.uint32(66).string(message.postalCode);
        }
        if (message.country !== "") {
            writer.uint32(74).string(message.country);
        }
        if (message.latitude !== 0) {
            writer.uint32(81).double(message.latitude);
        }
        if (message.longitude !== 0) {
            writer.uint32(89).double(message.longitude);
        }
        if (message.location !== "") {
            writer.uint32(98).string(message.location);
        }
        if (message.countyOrParish !== "") {
            writer.uint32(106).string(message.countyOrParish);
        }
        if (message.crossStreet !== "") {
            writer.uint32(114).string(message.crossStreet);
        }
        if (message.zoningDescription !== "") {
            writer.uint32(122).string(message.zoningDescription);
        }
        if (message.apiModificationTimestamp !== "") {
            writer.uint32(130).string(message.apiModificationTimestamp);
        }
        if (message.standardStatus !== "") {
            writer.uint32(138).string(message.standardStatus);
        }
        if (message.propertySubType !== "") {
            writer.uint32(146).string(message.propertySubType);
        }
        if (message.propertyType !== "") {
            writer.uint32(154).string(message.propertyType);
        }
        if (message.propertyDescription !== "") {
            writer.uint32(162).string(message.propertyDescription);
        }
        if (message.lotSizeAcres !== undefined) {
            writer.uint32(169).double(message.lotSizeAcres);
        }
        if (message.stories !== undefined) {
            writer.uint32(176).int32(message.stories);
        }
        if (message.yearBuilt !== undefined) {
            writer.uint32(184).int32(message.yearBuilt);
        }
        if (message.parkingTotal !== undefined) {
            writer.uint32(192).int32(message.parkingTotal);
        }
        if (message.capRate !== undefined) {
            writer.uint32(201).double(message.capRate);
        }
        if (message.daysOnMarket !== undefined) {
            writer.uint32(208).int32(message.daysOnMarket);
        }
        if (message.listPrice !== undefined) {
            writer.uint32(217).double(message.listPrice);
        }
        if (message.priceLabel !== undefined) {
            writer.uint32(226).string(message.priceLabel);
        }
        if (message.netOperatingIncome !== undefined) {
            writer.uint32(233).double(message.netOperatingIncome);
        }
        if (message.listAgentKeyNumeric !== undefined) {
            writer.uint32(240).int64(message.listAgentKeyNumeric);
        }
        if (message.expDataSourceKey !== undefined) {
            writer.uint32(248).int32(message.expDataSourceKey);
        }
        if (message.listingId !== "") {
            writer.uint32(258).string(message.listingId);
        }
        if (message.buildingClass !== undefined) {
            writer.uint32(266).string(message.buildingClass);
        }
        if (message.occupancyPct !== undefined) {
            writer.uint32(273).double(message.occupancyPct);
        }
        if (message.salePricePerUnit !== undefined) {
            writer.uint32(281).double(message.salePricePerUnit);
        }
        for (const v of message.highlights) {
            writer.uint32(290).string(v);
        }
        if (message.locationDescription !== undefined) {
            writer.uint32(298).string(message.locationDescription);
        }
        if (message.youTubeUrl !== undefined) {
            writer.uint32(306).string(message.youTubeUrl);
        }
        if (message.name !== undefined) {
            writer.uint32(314).string(message.name);
        }
        for (const v of message.media) {
            media_1.MediaCommercial.encode(v, writer.uint32(322).fork()).join();
        }
        for (const v of message.documents) {
            media_1.MediaCommercial.encode(v, writer.uint32(330).fork()).join();
        }
        for (const v of message.agents) {
            agent_1.AgentCommercial.encode(v, writer.uint32(338).fork()).join();
        }
        if (message.buildingSize !== undefined) {
            writer.uint32(346).string(message.buildingSize);
        }
        if (message.thumbnailImage !== undefined) {
            writer.uint32(354).string(message.thumbnailImage);
        }
        if (message.isSale !== false) {
            writer.uint32(360).bool(message.isSale);
        }
        if (message.standardizedAddress !== undefined) {
            exports.StandardizedAddress.encode(message.standardizedAddress, writer.uint32(378).fork()).join();
        }
        if (message.slug !== undefined) {
            writer.uint32(386).string(message.slug);
        }
        if (message.stateName !== undefined) {
            writer.uint32(394).string(message.stateName);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof wire_1.BinaryReader ? input : new wire_1.BinaryReader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseCommercialListingData();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1: {
                    if (tag !== 10) {
                        break;
                    }
                    message.odataId = reader.string();
                    continue;
                }
                case 2: {
                    if (tag !== 16) {
                        break;
                    }
                    message.listingKeyNumeric = longToNumber(reader.int64());
                    continue;
                }
                case 3: {
                    if (tag !== 26) {
                        break;
                    }
                    message.sourceSystemKey = reader.string();
                    continue;
                }
                case 4: {
                    if (tag !== 34) {
                        break;
                    }
                    message.sourceSystemName = reader.string();
                    continue;
                }
                case 5: {
                    if (tag !== 42) {
                        break;
                    }
                    message.unparsedAddress = reader.string();
                    continue;
                }
                case 6: {
                    if (tag !== 50) {
                        break;
                    }
                    message.city = reader.string();
                    continue;
                }
                case 7: {
                    if (tag !== 58) {
                        break;
                    }
                    message.stateOrProvince = reader.string();
                    continue;
                }
                case 8: {
                    if (tag !== 66) {
                        break;
                    }
                    message.postalCode = reader.string();
                    continue;
                }
                case 9: {
                    if (tag !== 74) {
                        break;
                    }
                    message.country = reader.string();
                    continue;
                }
                case 10: {
                    if (tag !== 81) {
                        break;
                    }
                    message.latitude = reader.double();
                    continue;
                }
                case 11: {
                    if (tag !== 89) {
                        break;
                    }
                    message.longitude = reader.double();
                    continue;
                }
                case 12: {
                    if (tag !== 98) {
                        break;
                    }
                    message.location = reader.string();
                    continue;
                }
                case 13: {
                    if (tag !== 106) {
                        break;
                    }
                    message.countyOrParish = reader.string();
                    continue;
                }
                case 14: {
                    if (tag !== 114) {
                        break;
                    }
                    message.crossStreet = reader.string();
                    continue;
                }
                case 15: {
                    if (tag !== 122) {
                        break;
                    }
                    message.zoningDescription = reader.string();
                    continue;
                }
                case 16: {
                    if (tag !== 130) {
                        break;
                    }
                    message.apiModificationTimestamp = reader.string();
                    continue;
                }
                case 17: {
                    if (tag !== 138) {
                        break;
                    }
                    message.standardStatus = reader.string();
                    continue;
                }
                case 18: {
                    if (tag !== 146) {
                        break;
                    }
                    message.propertySubType = reader.string();
                    continue;
                }
                case 19: {
                    if (tag !== 154) {
                        break;
                    }
                    message.propertyType = reader.string();
                    continue;
                }
                case 20: {
                    if (tag !== 162) {
                        break;
                    }
                    message.propertyDescription = reader.string();
                    continue;
                }
                case 21: {
                    if (tag !== 169) {
                        break;
                    }
                    message.lotSizeAcres = reader.double();
                    continue;
                }
                case 22: {
                    if (tag !== 176) {
                        break;
                    }
                    message.stories = reader.int32();
                    continue;
                }
                case 23: {
                    if (tag !== 184) {
                        break;
                    }
                    message.yearBuilt = reader.int32();
                    continue;
                }
                case 24: {
                    if (tag !== 192) {
                        break;
                    }
                    message.parkingTotal = reader.int32();
                    continue;
                }
                case 25: {
                    if (tag !== 201) {
                        break;
                    }
                    message.capRate = reader.double();
                    continue;
                }
                case 26: {
                    if (tag !== 208) {
                        break;
                    }
                    message.daysOnMarket = reader.int32();
                    continue;
                }
                case 27: {
                    if (tag !== 217) {
                        break;
                    }
                    message.listPrice = reader.double();
                    continue;
                }
                case 28: {
                    if (tag !== 226) {
                        break;
                    }
                    message.priceLabel = reader.string();
                    continue;
                }
                case 29: {
                    if (tag !== 233) {
                        break;
                    }
                    message.netOperatingIncome = reader.double();
                    continue;
                }
                case 30: {
                    if (tag !== 240) {
                        break;
                    }
                    message.listAgentKeyNumeric = longToNumber(reader.int64());
                    continue;
                }
                case 31: {
                    if (tag !== 248) {
                        break;
                    }
                    message.expDataSourceKey = reader.int32();
                    continue;
                }
                case 32: {
                    if (tag !== 258) {
                        break;
                    }
                    message.listingId = reader.string();
                    continue;
                }
                case 33: {
                    if (tag !== 266) {
                        break;
                    }
                    message.buildingClass = reader.string();
                    continue;
                }
                case 34: {
                    if (tag !== 273) {
                        break;
                    }
                    message.occupancyPct = reader.double();
                    continue;
                }
                case 35: {
                    if (tag !== 281) {
                        break;
                    }
                    message.salePricePerUnit = reader.double();
                    continue;
                }
                case 36: {
                    if (tag !== 290) {
                        break;
                    }
                    message.highlights.push(reader.string());
                    continue;
                }
                case 37: {
                    if (tag !== 298) {
                        break;
                    }
                    message.locationDescription = reader.string();
                    continue;
                }
                case 38: {
                    if (tag !== 306) {
                        break;
                    }
                    message.youTubeUrl = reader.string();
                    continue;
                }
                case 39: {
                    if (tag !== 314) {
                        break;
                    }
                    message.name = reader.string();
                    continue;
                }
                case 40: {
                    if (tag !== 322) {
                        break;
                    }
                    message.media.push(media_1.MediaCommercial.decode(reader, reader.uint32()));
                    continue;
                }
                case 41: {
                    if (tag !== 330) {
                        break;
                    }
                    message.documents.push(media_1.MediaCommercial.decode(reader, reader.uint32()));
                    continue;
                }
                case 42: {
                    if (tag !== 338) {
                        break;
                    }
                    message.agents.push(agent_1.AgentCommercial.decode(reader, reader.uint32()));
                    continue;
                }
                case 43: {
                    if (tag !== 346) {
                        break;
                    }
                    message.buildingSize = reader.string();
                    continue;
                }
                case 44: {
                    if (tag !== 354) {
                        break;
                    }
                    message.thumbnailImage = reader.string();
                    continue;
                }
                case 45: {
                    if (tag !== 360) {
                        break;
                    }
                    message.isSale = reader.bool();
                    continue;
                }
                case 47: {
                    if (tag !== 378) {
                        break;
                    }
                    message.standardizedAddress = exports.StandardizedAddress.decode(reader, reader.uint32());
                    continue;
                }
                case 48: {
                    if (tag !== 386) {
                        break;
                    }
                    message.slug = reader.string();
                    continue;
                }
                case 49: {
                    if (tag !== 394) {
                        break;
                    }
                    message.stateName = reader.string();
                    continue;
                }
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skip(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            odataId: isSet(object.odataId) ? globalThis.String(object.odataId) : "",
            listingKeyNumeric: isSet(object.listingKeyNumeric) ? globalThis.Number(object.listingKeyNumeric) : 0,
            sourceSystemKey: isSet(object.sourceSystemKey) ? globalThis.String(object.sourceSystemKey) : "",
            sourceSystemName: isSet(object.sourceSystemName) ? globalThis.String(object.sourceSystemName) : "",
            unparsedAddress: isSet(object.unparsedAddress) ? globalThis.String(object.unparsedAddress) : "",
            city: isSet(object.city) ? globalThis.String(object.city) : "",
            stateOrProvince: isSet(object.stateOrProvince) ? globalThis.String(object.stateOrProvince) : undefined,
            postalCode: isSet(object.postalCode) ? globalThis.String(object.postalCode) : undefined,
            country: isSet(object.country) ? globalThis.String(object.country) : "",
            latitude: isSet(object.latitude) ? globalThis.Number(object.latitude) : 0,
            longitude: isSet(object.longitude) ? globalThis.Number(object.longitude) : 0,
            location: isSet(object.location) ? globalThis.String(object.location) : "",
            countyOrParish: isSet(object.countyOrParish) ? globalThis.String(object.countyOrParish) : "",
            crossStreet: isSet(object.crossStreet) ? globalThis.String(object.crossStreet) : "",
            zoningDescription: isSet(object.zoningDescription) ? globalThis.String(object.zoningDescription) : "",
            apiModificationTimestamp: isSet(object.apiModificationTimestamp)
                ? globalThis.String(object.apiModificationTimestamp)
                : "",
            standardStatus: isSet(object.standardStatus) ? globalThis.String(object.standardStatus) : "",
            propertySubType: isSet(object.propertySubType) ? globalThis.String(object.propertySubType) : "",
            propertyType: isSet(object.propertyType) ? globalThis.String(object.propertyType) : "",
            propertyDescription: isSet(object.propertyDescription) ? globalThis.String(object.propertyDescription) : "",
            lotSizeAcres: isSet(object.lotSizeAcres) ? globalThis.Number(object.lotSizeAcres) : undefined,
            stories: isSet(object.stories) ? globalThis.Number(object.stories) : undefined,
            yearBuilt: isSet(object.yearBuilt) ? globalThis.Number(object.yearBuilt) : undefined,
            parkingTotal: isSet(object.parkingTotal) ? globalThis.Number(object.parkingTotal) : undefined,
            capRate: isSet(object.capRate) ? globalThis.Number(object.capRate) : undefined,
            daysOnMarket: isSet(object.daysOnMarket) ? globalThis.Number(object.daysOnMarket) : undefined,
            listPrice: isSet(object.listPrice) ? globalThis.Number(object.listPrice) : undefined,
            priceLabel: isSet(object.priceLabel) ? globalThis.String(object.priceLabel) : undefined,
            netOperatingIncome: isSet(object.netOperatingIncome) ? globalThis.Number(object.netOperatingIncome) : undefined,
            listAgentKeyNumeric: isSet(object.listAgentKeyNumeric)
                ? globalThis.Number(object.listAgentKeyNumeric)
                : undefined,
            expDataSourceKey: isSet(object.expDataSourceKey) ? globalThis.Number(object.expDataSourceKey) : undefined,
            listingId: isSet(object.listingId) ? globalThis.String(object.listingId) : "",
            buildingClass: isSet(object.buildingClass) ? globalThis.String(object.buildingClass) : undefined,
            occupancyPct: isSet(object.occupancyPct) ? globalThis.Number(object.occupancyPct) : undefined,
            salePricePerUnit: isSet(object.salePricePerUnit) ? globalThis.Number(object.salePricePerUnit) : undefined,
            highlights: globalThis.Array.isArray(object === null || object === void 0 ? void 0 : object.highlights)
                ? object.highlights.map((e) => globalThis.String(e))
                : [],
            locationDescription: isSet(object.locationDescription)
                ? globalThis.String(object.locationDescription)
                : undefined,
            youTubeUrl: isSet(object.youTubeUrl) ? globalThis.String(object.youTubeUrl) : undefined,
            name: isSet(object.name) ? globalThis.String(object.name) : undefined,
            media: globalThis.Array.isArray(object === null || object === void 0 ? void 0 : object.media) ? object.media.map((e) => media_1.MediaCommercial.fromJSON(e)) : [],
            documents: globalThis.Array.isArray(object === null || object === void 0 ? void 0 : object.documents)
                ? object.documents.map((e) => media_1.MediaCommercial.fromJSON(e))
                : [],
            agents: globalThis.Array.isArray(object === null || object === void 0 ? void 0 : object.agents)
                ? object.agents.map((e) => agent_1.AgentCommercial.fromJSON(e))
                : [],
            buildingSize: isSet(object.buildingSize) ? globalThis.String(object.buildingSize) : undefined,
            thumbnailImage: isSet(object.thumbnailImage) ? globalThis.String(object.thumbnailImage) : undefined,
            isSale: isSet(object.isSale) ? globalThis.Boolean(object.isSale) : false,
            standardizedAddress: isSet(object.standardizedAddress)
                ? exports.StandardizedAddress.fromJSON(object.standardizedAddress)
                : undefined,
            slug: isSet(object.slug) ? globalThis.String(object.slug) : undefined,
            stateName: isSet(object.stateName) ? globalThis.String(object.stateName) : undefined,
        };
    },
    toJSON(message) {
        var _a, _b, _c, _d;
        const obj = {};
        if (message.odataId !== "") {
            obj.odataId = message.odataId;
        }
        if (message.listingKeyNumeric !== 0) {
            obj.listingKeyNumeric = Math.round(message.listingKeyNumeric);
        }
        if (message.sourceSystemKey !== "") {
            obj.sourceSystemKey = message.sourceSystemKey;
        }
        if (message.sourceSystemName !== "") {
            obj.sourceSystemName = message.sourceSystemName;
        }
        if (message.unparsedAddress !== "") {
            obj.unparsedAddress = message.unparsedAddress;
        }
        if (message.city !== "") {
            obj.city = message.city;
        }
        if (message.stateOrProvince !== undefined) {
            obj.stateOrProvince = message.stateOrProvince;
        }
        if (message.postalCode !== undefined) {
            obj.postalCode = message.postalCode;
        }
        if (message.country !== "") {
            obj.country = message.country;
        }
        if (message.latitude !== 0) {
            obj.latitude = message.latitude;
        }
        if (message.longitude !== 0) {
            obj.longitude = message.longitude;
        }
        if (message.location !== "") {
            obj.location = message.location;
        }
        if (message.countyOrParish !== "") {
            obj.countyOrParish = message.countyOrParish;
        }
        if (message.crossStreet !== "") {
            obj.crossStreet = message.crossStreet;
        }
        if (message.zoningDescription !== "") {
            obj.zoningDescription = message.zoningDescription;
        }
        if (message.apiModificationTimestamp !== "") {
            obj.apiModificationTimestamp = message.apiModificationTimestamp;
        }
        if (message.standardStatus !== "") {
            obj.standardStatus = message.standardStatus;
        }
        if (message.propertySubType !== "") {
            obj.propertySubType = message.propertySubType;
        }
        if (message.propertyType !== "") {
            obj.propertyType = message.propertyType;
        }
        if (message.propertyDescription !== "") {
            obj.propertyDescription = message.propertyDescription;
        }
        if (message.lotSizeAcres !== undefined) {
            obj.lotSizeAcres = message.lotSizeAcres;
        }
        if (message.stories !== undefined) {
            obj.stories = Math.round(message.stories);
        }
        if (message.yearBuilt !== undefined) {
            obj.yearBuilt = Math.round(message.yearBuilt);
        }
        if (message.parkingTotal !== undefined) {
            obj.parkingTotal = Math.round(message.parkingTotal);
        }
        if (message.capRate !== undefined) {
            obj.capRate = message.capRate;
        }
        if (message.daysOnMarket !== undefined) {
            obj.daysOnMarket = Math.round(message.daysOnMarket);
        }
        if (message.listPrice !== undefined) {
            obj.listPrice = message.listPrice;
        }
        if (message.priceLabel !== undefined) {
            obj.priceLabel = message.priceLabel;
        }
        if (message.netOperatingIncome !== undefined) {
            obj.netOperatingIncome = message.netOperatingIncome;
        }
        if (message.listAgentKeyNumeric !== undefined) {
            obj.listAgentKeyNumeric = Math.round(message.listAgentKeyNumeric);
        }
        if (message.expDataSourceKey !== undefined) {
            obj.expDataSourceKey = Math.round(message.expDataSourceKey);
        }
        if (message.listingId !== "") {
            obj.listingId = message.listingId;
        }
        if (message.buildingClass !== undefined) {
            obj.buildingClass = message.buildingClass;
        }
        if (message.occupancyPct !== undefined) {
            obj.occupancyPct = message.occupancyPct;
        }
        if (message.salePricePerUnit !== undefined) {
            obj.salePricePerUnit = message.salePricePerUnit;
        }
        if ((_a = message.highlights) === null || _a === void 0 ? void 0 : _a.length) {
            obj.highlights = message.highlights;
        }
        if (message.locationDescription !== undefined) {
            obj.locationDescription = message.locationDescription;
        }
        if (message.youTubeUrl !== undefined) {
            obj.youTubeUrl = message.youTubeUrl;
        }
        if (message.name !== undefined) {
            obj.name = message.name;
        }
        if ((_b = message.media) === null || _b === void 0 ? void 0 : _b.length) {
            obj.media = message.media.map((e) => media_1.MediaCommercial.toJSON(e));
        }
        if ((_c = message.documents) === null || _c === void 0 ? void 0 : _c.length) {
            obj.documents = message.documents.map((e) => media_1.MediaCommercial.toJSON(e));
        }
        if ((_d = message.agents) === null || _d === void 0 ? void 0 : _d.length) {
            obj.agents = message.agents.map((e) => agent_1.AgentCommercial.toJSON(e));
        }
        if (message.buildingSize !== undefined) {
            obj.buildingSize = message.buildingSize;
        }
        if (message.thumbnailImage !== undefined) {
            obj.thumbnailImage = message.thumbnailImage;
        }
        if (message.isSale !== false) {
            obj.isSale = message.isSale;
        }
        if (message.standardizedAddress !== undefined) {
            obj.standardizedAddress = exports.StandardizedAddress.toJSON(message.standardizedAddress);
        }
        if (message.slug !== undefined) {
            obj.slug = message.slug;
        }
        if (message.stateName !== undefined) {
            obj.stateName = message.stateName;
        }
        return obj;
    },
    create(base) {
        return exports.CommercialListingData.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial(object) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z, _0, _1, _2, _3, _4, _5, _6, _7, _8, _9, _10, _11, _12, _13, _14, _15, _16, _17, _18, _19, _20, _21, _22;
        const message = createBaseCommercialListingData();
        message.odataId = (_a = object.odataId) !== null && _a !== void 0 ? _a : "";
        message.listingKeyNumeric = (_b = object.listingKeyNumeric) !== null && _b !== void 0 ? _b : 0;
        message.sourceSystemKey = (_c = object.sourceSystemKey) !== null && _c !== void 0 ? _c : "";
        message.sourceSystemName = (_d = object.sourceSystemName) !== null && _d !== void 0 ? _d : "";
        message.unparsedAddress = (_e = object.unparsedAddress) !== null && _e !== void 0 ? _e : "";
        message.city = (_f = object.city) !== null && _f !== void 0 ? _f : "";
        message.stateOrProvince = (_g = object.stateOrProvince) !== null && _g !== void 0 ? _g : undefined;
        message.postalCode = (_h = object.postalCode) !== null && _h !== void 0 ? _h : undefined;
        message.country = (_j = object.country) !== null && _j !== void 0 ? _j : "";
        message.latitude = (_k = object.latitude) !== null && _k !== void 0 ? _k : 0;
        message.longitude = (_l = object.longitude) !== null && _l !== void 0 ? _l : 0;
        message.location = (_m = object.location) !== null && _m !== void 0 ? _m : "";
        message.countyOrParish = (_o = object.countyOrParish) !== null && _o !== void 0 ? _o : "";
        message.crossStreet = (_p = object.crossStreet) !== null && _p !== void 0 ? _p : "";
        message.zoningDescription = (_q = object.zoningDescription) !== null && _q !== void 0 ? _q : "";
        message.apiModificationTimestamp = (_r = object.apiModificationTimestamp) !== null && _r !== void 0 ? _r : "";
        message.standardStatus = (_s = object.standardStatus) !== null && _s !== void 0 ? _s : "";
        message.propertySubType = (_t = object.propertySubType) !== null && _t !== void 0 ? _t : "";
        message.propertyType = (_u = object.propertyType) !== null && _u !== void 0 ? _u : "";
        message.propertyDescription = (_v = object.propertyDescription) !== null && _v !== void 0 ? _v : "";
        message.lotSizeAcres = (_w = object.lotSizeAcres) !== null && _w !== void 0 ? _w : undefined;
        message.stories = (_x = object.stories) !== null && _x !== void 0 ? _x : undefined;
        message.yearBuilt = (_y = object.yearBuilt) !== null && _y !== void 0 ? _y : undefined;
        message.parkingTotal = (_z = object.parkingTotal) !== null && _z !== void 0 ? _z : undefined;
        message.capRate = (_0 = object.capRate) !== null && _0 !== void 0 ? _0 : undefined;
        message.daysOnMarket = (_1 = object.daysOnMarket) !== null && _1 !== void 0 ? _1 : undefined;
        message.listPrice = (_2 = object.listPrice) !== null && _2 !== void 0 ? _2 : undefined;
        message.priceLabel = (_3 = object.priceLabel) !== null && _3 !== void 0 ? _3 : undefined;
        message.netOperatingIncome = (_4 = object.netOperatingIncome) !== null && _4 !== void 0 ? _4 : undefined;
        message.listAgentKeyNumeric = (_5 = object.listAgentKeyNumeric) !== null && _5 !== void 0 ? _5 : undefined;
        message.expDataSourceKey = (_6 = object.expDataSourceKey) !== null && _6 !== void 0 ? _6 : undefined;
        message.listingId = (_7 = object.listingId) !== null && _7 !== void 0 ? _7 : "";
        message.buildingClass = (_8 = object.buildingClass) !== null && _8 !== void 0 ? _8 : undefined;
        message.occupancyPct = (_9 = object.occupancyPct) !== null && _9 !== void 0 ? _9 : undefined;
        message.salePricePerUnit = (_10 = object.salePricePerUnit) !== null && _10 !== void 0 ? _10 : undefined;
        message.highlights = ((_11 = object.highlights) === null || _11 === void 0 ? void 0 : _11.map((e) => e)) || [];
        message.locationDescription = (_12 = object.locationDescription) !== null && _12 !== void 0 ? _12 : undefined;
        message.youTubeUrl = (_13 = object.youTubeUrl) !== null && _13 !== void 0 ? _13 : undefined;
        message.name = (_14 = object.name) !== null && _14 !== void 0 ? _14 : undefined;
        message.media = ((_15 = object.media) === null || _15 === void 0 ? void 0 : _15.map((e) => media_1.MediaCommercial.fromPartial(e))) || [];
        message.documents = ((_16 = object.documents) === null || _16 === void 0 ? void 0 : _16.map((e) => media_1.MediaCommercial.fromPartial(e))) || [];
        message.agents = ((_17 = object.agents) === null || _17 === void 0 ? void 0 : _17.map((e) => agent_1.AgentCommercial.fromPartial(e))) || [];
        message.buildingSize = (_18 = object.buildingSize) !== null && _18 !== void 0 ? _18 : undefined;
        message.thumbnailImage = (_19 = object.thumbnailImage) !== null && _19 !== void 0 ? _19 : undefined;
        message.isSale = (_20 = object.isSale) !== null && _20 !== void 0 ? _20 : false;
        message.standardizedAddress = (object.standardizedAddress !== undefined && object.standardizedAddress !== null)
            ? exports.StandardizedAddress.fromPartial(object.standardizedAddress)
            : undefined;
        message.slug = (_21 = object.slug) !== null && _21 !== void 0 ? _21 : undefined;
        message.stateName = (_22 = object.stateName) !== null && _22 !== void 0 ? _22 : undefined;
        return message;
    },
};
function createBaseStandardizedAddress() {
    return {
        unitNumber: undefined,
        streetNumber: undefined,
        streetName: undefined,
        streetPrefix: undefined,
        streetSuffix: undefined,
        streetDirPrefix: undefined,
        streetDirSuffix: undefined,
        city: undefined,
        stateProvince: undefined,
        postalCode: undefined,
        precisionCode: undefined,
    };
}
exports.StandardizedAddress = {
    encode(message, writer = new wire_1.BinaryWriter()) {
        if (message.unitNumber !== undefined) {
            writer.uint32(10).string(message.unitNumber);
        }
        if (message.streetNumber !== undefined) {
            writer.uint32(18).string(message.streetNumber);
        }
        if (message.streetName !== undefined) {
            writer.uint32(26).string(message.streetName);
        }
        if (message.streetPrefix !== undefined) {
            writer.uint32(34).string(message.streetPrefix);
        }
        if (message.streetSuffix !== undefined) {
            writer.uint32(42).string(message.streetSuffix);
        }
        if (message.streetDirPrefix !== undefined) {
            writer.uint32(50).string(message.streetDirPrefix);
        }
        if (message.streetDirSuffix !== undefined) {
            writer.uint32(58).string(message.streetDirSuffix);
        }
        if (message.city !== undefined) {
            writer.uint32(66).string(message.city);
        }
        if (message.stateProvince !== undefined) {
            writer.uint32(74).string(message.stateProvince);
        }
        if (message.postalCode !== undefined) {
            writer.uint32(82).string(message.postalCode);
        }
        if (message.precisionCode !== undefined) {
            writer.uint32(90).string(message.precisionCode);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof wire_1.BinaryReader ? input : new wire_1.BinaryReader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseStandardizedAddress();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1: {
                    if (tag !== 10) {
                        break;
                    }
                    message.unitNumber = reader.string();
                    continue;
                }
                case 2: {
                    if (tag !== 18) {
                        break;
                    }
                    message.streetNumber = reader.string();
                    continue;
                }
                case 3: {
                    if (tag !== 26) {
                        break;
                    }
                    message.streetName = reader.string();
                    continue;
                }
                case 4: {
                    if (tag !== 34) {
                        break;
                    }
                    message.streetPrefix = reader.string();
                    continue;
                }
                case 5: {
                    if (tag !== 42) {
                        break;
                    }
                    message.streetSuffix = reader.string();
                    continue;
                }
                case 6: {
                    if (tag !== 50) {
                        break;
                    }
                    message.streetDirPrefix = reader.string();
                    continue;
                }
                case 7: {
                    if (tag !== 58) {
                        break;
                    }
                    message.streetDirSuffix = reader.string();
                    continue;
                }
                case 8: {
                    if (tag !== 66) {
                        break;
                    }
                    message.city = reader.string();
                    continue;
                }
                case 9: {
                    if (tag !== 74) {
                        break;
                    }
                    message.stateProvince = reader.string();
                    continue;
                }
                case 10: {
                    if (tag !== 82) {
                        break;
                    }
                    message.postalCode = reader.string();
                    continue;
                }
                case 11: {
                    if (tag !== 90) {
                        break;
                    }
                    message.precisionCode = reader.string();
                    continue;
                }
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skip(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            unitNumber: isSet(object.unitNumber) ? globalThis.String(object.unitNumber) : undefined,
            streetNumber: isSet(object.streetNumber) ? globalThis.String(object.streetNumber) : undefined,
            streetName: isSet(object.streetName) ? globalThis.String(object.streetName) : undefined,
            streetPrefix: isSet(object.streetPrefix) ? globalThis.String(object.streetPrefix) : undefined,
            streetSuffix: isSet(object.streetSuffix) ? globalThis.String(object.streetSuffix) : undefined,
            streetDirPrefix: isSet(object.streetDirPrefix) ? globalThis.String(object.streetDirPrefix) : undefined,
            streetDirSuffix: isSet(object.streetDirSuffix) ? globalThis.String(object.streetDirSuffix) : undefined,
            city: isSet(object.city) ? globalThis.String(object.city) : undefined,
            stateProvince: isSet(object.stateProvince) ? globalThis.String(object.stateProvince) : undefined,
            postalCode: isSet(object.postalCode) ? globalThis.String(object.postalCode) : undefined,
            precisionCode: isSet(object.precisionCode) ? globalThis.String(object.precisionCode) : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.unitNumber !== undefined) {
            obj.unitNumber = message.unitNumber;
        }
        if (message.streetNumber !== undefined) {
            obj.streetNumber = message.streetNumber;
        }
        if (message.streetName !== undefined) {
            obj.streetName = message.streetName;
        }
        if (message.streetPrefix !== undefined) {
            obj.streetPrefix = message.streetPrefix;
        }
        if (message.streetSuffix !== undefined) {
            obj.streetSuffix = message.streetSuffix;
        }
        if (message.streetDirPrefix !== undefined) {
            obj.streetDirPrefix = message.streetDirPrefix;
        }
        if (message.streetDirSuffix !== undefined) {
            obj.streetDirSuffix = message.streetDirSuffix;
        }
        if (message.city !== undefined) {
            obj.city = message.city;
        }
        if (message.stateProvince !== undefined) {
            obj.stateProvince = message.stateProvince;
        }
        if (message.postalCode !== undefined) {
            obj.postalCode = message.postalCode;
        }
        if (message.precisionCode !== undefined) {
            obj.precisionCode = message.precisionCode;
        }
        return obj;
    },
    create(base) {
        return exports.StandardizedAddress.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial(object) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l;
        const message = createBaseStandardizedAddress();
        message.unitNumber = (_a = object.unitNumber) !== null && _a !== void 0 ? _a : undefined;
        message.streetNumber = (_b = object.streetNumber) !== null && _b !== void 0 ? _b : undefined;
        message.streetName = (_c = object.streetName) !== null && _c !== void 0 ? _c : undefined;
        message.streetPrefix = (_d = object.streetPrefix) !== null && _d !== void 0 ? _d : undefined;
        message.streetSuffix = (_e = object.streetSuffix) !== null && _e !== void 0 ? _e : undefined;
        message.streetDirPrefix = (_f = object.streetDirPrefix) !== null && _f !== void 0 ? _f : undefined;
        message.streetDirSuffix = (_g = object.streetDirSuffix) !== null && _g !== void 0 ? _g : undefined;
        message.city = (_h = object.city) !== null && _h !== void 0 ? _h : undefined;
        message.stateProvince = (_j = object.stateProvince) !== null && _j !== void 0 ? _j : undefined;
        message.postalCode = (_k = object.postalCode) !== null && _k !== void 0 ? _k : undefined;
        message.precisionCode = (_l = object.precisionCode) !== null && _l !== void 0 ? _l : undefined;
        return message;
    },
};
function longToNumber(int64) {
    const num = globalThis.Number(int64.toString());
    if (num > globalThis.Number.MAX_SAFE_INTEGER) {
        throw new globalThis.Error("Value is larger than Number.MAX_SAFE_INTEGER");
    }
    if (num < globalThis.Number.MIN_SAFE_INTEGER) {
        throw new globalThis.Error("Value is smaller than Number.MIN_SAFE_INTEGER");
    }
    return num;
}
function isSet(value) {
    return value !== null && value !== undefined;
}
//# sourceMappingURL=commercial_listing.js.map